import { useMemo } from 'react';
import { AssistantControllerBaseConfig } from '../../base';
import { AssistantLinkController } from './interviewLinkInterface';
import { AssistantLinkViewProps } from './interviewLinkProps';

export function createLinkController(
    config: AssistantControllerBaseConfig
): AssistantLinkController {
    const { kernel } = config;
    return {
        useProps(item, props): AssistantLinkViewProps {
            const link = useMemo(() => {
                return config.navigation.thread.create({
                    location: props.location,
                    thread: item.accept.data,
                });
            }, [props.location]);
            return {
                redirect: {
                    ...link,
                    replace: true,
                },
            };
        },
    };
}
